import {
  DtoKeys, Services, Helpers, Constants,
} from '@bode-canada/core';

const {
  ListingFlowDtoKey,
  AddressDtoKey,
  NewListingDtoKey,
  PropertyDtoKey,
} = DtoKeys;

export default class ListingMapper {
  static mapFromDto(listing) {
    const closedDate = new Date(listing[NewListingDtoKey.CLOSED_AT] || new Date());
    const daysOnMarket = Helpers.DateHelper.getTimeInDifferentUnit(
      closedDate - new Date(listing[NewListingDtoKey.PUBLISHED_AT]),
      Constants.DateUnit.Milliseconds,
      Constants.DateUnit.Day,
    );
    const property = listing[ListingFlowDtoKey.PROPERTY];
    const address = property[ListingFlowDtoKey.ADDRESS];

    return {
      lat: address[AddressDtoKey.LATITUDE],
      lon: address[AddressDtoKey.LONGITUDE],
      addressId: address[AddressDtoKey.ID],
      address: this.#getAddress(address),
      city: address[AddressDtoKey.CITY],
      province: address[AddressDtoKey.STATE],
      closedAt: listing[NewListingDtoKey.CLOSED_AT],
      listingId: Number(listing[NewListingDtoKey.ID]),
      beds: property.totalBeds,
      fullBaths: property.totalBaths,
      buildingClass: property[PropertyDtoKey.BUILDING_CLASS],
      buildingType: property[PropertyDtoKey.BUILDING_TYPE],
      finishedSqft: property[PropertyDtoKey.TOTAL_FINISH_SQFT],
      listPrice: listing[NewListingDtoKey.ORIGINAL_PRICE] || listing[NewListingDtoKey.PRICE],
      price: listing[NewListingDtoKey.PRICE],
      soldPrice: listing[NewListingDtoKey.PRICE],
      origin: listing[NewListingDtoKey.ORIGIN],
      status: listing[NewListingDtoKey.STATUS],
      daysOnMarket: Math.round(daysOnMarket),
      image: {
        lowResUrl: listing[NewListingDtoKey.IMAGES][0]?.lowResUrl,
      },
      match: listing.match,
      halfBaths: 0,
      halfBeds: 0,
    };
  }

  static getFullAddress(address) {
    return Helpers.StringHelper.joinStrings([
      this.#getAddress(address),
      address[AddressDtoKey.CITY],
      address[AddressDtoKey.STATE],
    ], ' ');
  }

  static #getAddress(address) {
    const streetAddress = Services.CleanupAddressService.getAddress(address);

    return Helpers.StringHelper.joinStrings([
      address[AddressDtoKey.UNIT],
      streetAddress,
    ], ' ');
  }
}
